.form {
  flex: 1;
  display: flex;
  flex-direction: column;

  @media (max-width: 991px) {
    padding: 0 !important;
  }

  @media (min-width: 992px) {
    min-height: 550px;
    &::-webkit-scrollbar {
      width: 5px;
    }

    &::-webkit-scrollbar-track {
      background: #f1f1f1;
      border-radius: 10px;
    }

    &::-webkit-scrollbar-thumb {
      background: #888;
      border-radius: 10px;
    }

    &::-webkit-scrollbar-thumb:hover {
      background: #555;
      border-radius: 10px;
    }
  }
}
